import React from "react";
import TextTruncate from "./TextTruncate";
import CopyIconAntStyle from "./CopyIconAntStyle";

type Props = {
  text?: string;
  maxWords: number;
  copiedLabel?: string;
};

const CopyableTruncate: React.FC<Props> = ({
  text = "--",
  maxWords,
  copiedLabel,
}) => {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        maxWidth: "100%",
      }}
    >
      <span style={{ minWidth: 0 }}>
        <TextTruncate text={text} maxWords={maxWords} />
      </span>

      <CopyIconAntStyle text={text} label={copiedLabel} />
    </span>
  );
};

export default CopyableTruncate;
